export default "__VITE_ASSET__DlLMOAH5__"